"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockExperiment = void 0;
function mockExperiment(overrides = {}) {
    return {
        date_end: '2021-10-23T11:44:35.000Z',
        date_start: '2021-10-13T11:44:33.000Z',
        experiment_variants: [],
        id: 1,
        name: 'mock experiment',
        slug: 'mock_experiment',
        ...overrides,
    };
}
exports.mockExperiment = mockExperiment;
